import { render, staticRenderFns } from "./ContratosMainList.vue?vue&type=template&id=57c420a9&scoped=true&"
import script from "./ContratosMainList.vue?vue&type=script&lang=js&"
export * from "./ContratosMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c420a9",
  null
  
)

export default component.exports